
import { z } from "zod";

export const charteFormSchema = z.object({
  firstName: z.string().min(2, "Le prénom doit contenir au moins 2 caractères"),
  lastName: z.string().min(2, "Le nom doit contenir au moins 2 caractères"),
  email: z.string().email("Email invalide"),
  phone: z.string().optional(),
  acceptCharter: z.boolean().refine(val => val === true, {
    message: "Vous devez accepter la charte républicaine"
  }),
  isFrenchCitizen: z.boolean().refine(val => val === true, {
    message: "Vous devez être résident(e) en France ou citoyen(ne) français(e) pour signer la charte"
  })
});

export type CharteFormValues = z.infer<typeof charteFormSchema>;

export interface CharteSignatureFormProps {
  onSuccess: () => void;
}
